import React from "react";
import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { CONTACT } from "../mock";

const Location = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  // Google Maps embed of the address area
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.4747729117197!2d77.6896!3d13.0064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDAwJzIzLjAiTiA3N8KwNDEnMjIuNiJF!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin";
  return (
    <section id="contact" className="location">
      <div className="container">
        <div className="location-head">
          <span className="section-label center">Find Us</span>
          <h2 className="section-title">Visit Guruji's<br/><em>Astro Center</em></h2>
        </div>
        <div className="location-grid">
          <div className="location-map">
            <iframe
              src={mapSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Pandit C. S. Joshi Astro Center"
              allowFullScreen
            />
          </div>
          <div className="contact-list">
            <div className="contact-item">
              <div className="contact-icon"><MapPin size={18} /></div>
              <div>
                <div className="contact-label">Address</div>
                <div className="contact-value">{CONTACT.address}</div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><Phone size={18} /></div>
              <div>
                <div className="contact-label">Call</div>
                <div className="contact-value"><a href={`tel:${CONTACT.callNumber}`}>{CONTACT.callDisplay}</a></div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><MessageCircle size={18} /></div>
              <div>
                <div className="contact-label">WhatsApp</div>
                <div className="contact-value"><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer">{CONTACT.whatsappDisplay}</a></div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><Mail size={18} /></div>
              <div>
                <div className="contact-label">Email</div>
                <div className="contact-value"><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon"><Clock size={18} /></div>
              <div>
                <div className="contact-label">Consultation Hours</div>
                <div className="contact-value">{CONTACT.hours}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
